import {Auth, API, Logger} from "aws-amplify";
const logger = new Logger("foo");

let apiName = process.env.REACT_APP_APINAME;
let path = "";
let requestBody = "";

class MerchantService {

    async getMerchantDetail(callback){
        
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_GETMERCHANTDETAILS;
        requestBody = {
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(response => {
            return callback(null,response);
        }).catch(error => {
            console.debug(error);
            return callback(error,null);
        });
    } 

    async generateApiKey(email, callback){

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_GENERATEAPIKEY;
        requestBody = {
            body: {
                email: email
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(response => {
            return callback(null,response);
        }).catch(error => {
            console.debug(error);
            return callback(error,null);
        });
    }

    async merchantKey(userID, keyType, callback){

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_MERCHANTKEY;
        requestBody = {
            body: {
                user_id: userID,
                type: keyType
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(response => {
            return callback(null,response);
        }).catch(error => {
            console.debug(error);
            return callback(error,null);
        });
    }

    async generateMerchantKey(userID, callback){

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_MERCHANTKEY;
        requestBody = {
            body: {
                user_id: userID,
                type: "private_key"
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(response => {
            return callback(null,response);
        }).catch(error => {
            logger.error("error happened", error);
            return callback(error,null);
        });

    }

    async setEndpoint(url, callback){

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_SETENDPOINT;
        requestBody = {
            body: {
                endpoint: url
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(response => {
            return callback(null,response);
        }).catch(error => {
            console.debug(error);
            return callback(error,null);
        });
    }
    
}

export default MerchantService;